// import dJSON from 'dirty-json';
// import '../node_modules/@lottiefiles/lottie-player/dist/lottie-player';

import './js/base/base-start';
import './js/global';

// modules - core
import './modules/core/accordion/module';

// modules
import './modules/theme/login-help-buttons/module';
import './modules/theme/homepage/module';
import './modules/evox/account-overview-widget/module';
import './modules/evox/account-overview-page/module';
// import './modules/evox/account-pagination/module';
import './modules/evox/invoices-modal/module';

// layouts

// leave me last
import './js/base/base-end';
